import React from 'react';
import { useTheme } from '@emotion/react';
import { useLocation } from 'react-router-dom';
// Mui Components
import { Typography, Box } from '@mui/material';
// Components
import HorizontalDivider from '../common/HorizontalDivider';
// Images
import LogoCertiSur from '../../utils/images/logo_certisur.png';
import LogoResponsableRegistrado from '../../utils/images/logo_rnbd.png';
import LogoRenaper from '../../utils/images/logo_renaper.png';
import logoOsdeWhite from '../../assets/images/logo_osde_blanco.png';

export default function Footer({ loader }) {
  const theme = useTheme();
  const location = useLocation();
  const routesWithFooter = ['/prestador/misConsultorios', '/prestador/dashboard'];
  const showFooter = loader === false && routesWithFooter.includes(location.pathname);

  return (
    showFooter && (
      <Box
        sx={{
          width: '100%',
          padding: '40px 137px',
          backgroundColor: theme.palette.primary.main,
          display: 'flex',
          position: 'relative',
          zIndex: 6,
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            flexDirection: 'column',
            height: '100%',
            gap: '1.4rem',
            zIndex: 10
          }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <Box
              component="img"
              sx={{ width: '106px', height: '41px' }}
              alt="img not found"
              src={logoOsdeWhite}
            />
            <Box sx={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
              <Box
                component="img"
                src={LogoCertiSur}
                alt="img not found"
                sx={{
                  objectFit: 'contain',
                  cursor: 'pointer',
                  transition: 'filter 0.3s ease-in-out',
                  '&:hover': {
                    filter: 'brightness(1.2)'
                  }
                }}
              />
              <Box
                component="img"
                src={LogoResponsableRegistrado}
                alt="img not found"
                sx={{
                  objectFit: 'contain',
                  cursor: 'pointer',
                  transition: 'filter 0.3s ease-in-out',
                  '&:hover': {
                    filter: 'brightness(1.2)'
                  }
                }}
              />
              <Box
                component="img"
                src={LogoRenaper}
                alt="img not found"
                sx={{
                  objectFit: 'contain',
                  cursor: 'pointer',
                  transition: 'filter 0.3s ease-in-out',
                  '&:hover': {
                    filter: 'brightness(1.2)'
                  }
                }}
              />
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              gap: '1.5rem',
              width: '100%',
              flexDirection: 'column'
            }}>
            <HorizontalDivider color={theme.palette.backgroundSecondary.main} />
            <Typography variant="legalM" color={theme.palette.white.main}>
              ©OSDE 2015 - Todos los derechos reservados - Av. Leandro N. Alem 1067 - Piso 9 -
              C1001AAF - Buenos Aires - Superintendencia de Servicios de Salud - Órgano de Control
              de Obras Sociales y Entidades de Medicina Prepaga - 0800-222-SALUD (72583) -
              www.sssalud.gob.ar - R.N.E.M.P. (Prov.) 1408 - R.N.O.S. 4-0080-0.
            </Typography>
            <Typography variant="legalM" color={theme.palette.white.main}>
              Política de privacidad | Defensa del consumidor | Defensa de las y los consumidores |
              Dirección Nacional de Datos Personales | Libro de quejas online
            </Typography>
          </Box>
        </Box>
      </Box>
    )
  );
}
